export const customHeapEvent = (event: string, properties?: Record<string, unknown>) => {
  if (window?.heap?.loaded && typeof window?.heap?.track === 'function') {
    window?.heap?.track?.(event, properties);
  }
};
